<template>
  <div class="correct-additional section_">
    <correct-title title="附加信息" />
    <div class="additional-content">
      <a-form-model-item class="flex_ correct-form-item" :class="{ 'mobile-remark-item': isMobile }" label="备注（可选）" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-textarea :rows="isMobile ? 3 : 1" v-model="policyForm.remark" placeholder="请输入备注" />
      </a-form-model-item>
      <a-form-model-item class="flex_ correct-form-item" :class="{ 'mobile-remark-item': isMobile }" label="批改记录" :label-col="labelCol" :wrapper-col="wrapperCol">
        <p class="records" v-html="policyForm.changeContent"></p>
      </a-form-model-item>
      <a-form-model-item class="flex_ correct-form-item upload-form-item" :class="{ 'mobile-remark-item': isMobile }" label="资料上传" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-upload :disabled="uploadLoading" name="file" :file-list="fileList" :remove="fileRemove" :multiple="true" :before-upload="beforeUpload" :customRequest="handleUpload">
          <a-button :loading="uploadLoading" class="upload-btn">上传</a-button>
        </a-upload>
      </a-form-model-item>
    </div>
  </div>
</template>

<script>
import correctTitle from './title';
import api from '../api/index';
export default {
  name: 'additional',
  components: {
    correctTitle
  },
  inject: ['isMobile'],
  props: {
    policyForm: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      labelCol: { xs: 24, sm: 24, md: 4, lg: 2 },
      wrapperCol: { xs: 24, sm: 24, md: 20, lg: 22 },
      uploadLoading: false, // 上传loading
      fileList: [], // 文件列表
      filesResult: [] // 上传后接口返回数据集合
    };
  },
  methods: {
    // 文件删除
    fileRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.filesResult.splice(index, 1);
      this.fileList = newFileList;
      this.$emit('uploadFile', this.filesResult);
    },
    // 上传前事件
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
    },
    // 上传文件
    handleUpload(options) {
      this.uploadLoading = true;
      let formData = new FormData();
      formData.append('multipartFile', options.file);
      formData.append('policyId', this.policyForm.policyId);
      formData.append('invoiceNo', this.policyForm.invoiceNo || '');
      formData.append('fileType', '06');
      api
        .batchUploadFile(formData)
        .then(res => {
          const { returnCode, content } = res.data;
          if (returnCode === '00') {
            this.filesResult.push(content);
            this.$emit('uploadFile', this.filesResult);
          }
        })
        .finally(() => {
          this.uploadLoading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.correct-additional {
  .additional-content {
    .upload-form-item {
      align-items: flex-start !important;
    }
    .upload-btn {
      width: 80px;
      height: 25px;
      color: #ffffff;
      line-height: 17px;
      background: #ffaa39;
      border-radius: 3px;
    }
  }
  .records {
    min-height: 30px;
		line-height: 1.5;
		padding: 4px 11px;
    border: 1px solid #d9d9d9;
    margin-bottom: 0;
    border-radius: 4px;
		background-color: #f5f5f5;
  }
}
.mobile_ {
  .correct-additional {
    &.section_ {
      padding: 18px 20px !important;
      .ant-form-item {
        border-bottom: 0 !important;
      }
      .ant-form-item-label {
        margin-bottom: 14px;
      }
      .mobile-remark-item {
        flex-wrap: wrap;
        justify-content: flex-start;
      }
      .upload-form-item {
        margin-top: 14px;
        .ant-form-item-label {
          margin-bottom: 8px;
        }
      }
    }
  }
}
</style>
